export default __webpack_public_path__ + "static/media/Easy_Learning.27119e94.png";